import React, { PureComponent } from 'react';
import './styles.scss';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'ssr-test': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >;
    }
  }
}
export class SsrTest extends PureComponent<
  { real: string },
  { counter: number }
> {
  state = {
    counter: 0,
  };

  componentDidMount(): void {
    setInterval(
      () => this.setState(({ counter }) => ({ counter: counter + 1 })),
      1000
    );
  }

  render(): JSX.Element {
    const { counter } = this.state;
    return (
      <ssr-test>
        <div className="hello">Hello World!</div>
        <div className="counter">Counter: {counter}</div>
      </ssr-test>
    );
  }
}
